module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "select-market-demo"
  }, [_c('div', {
    staticClass: "select-market-demo__selection-area"
  }, [_c('h5', {
    staticClass: "center"
  }, [_vm._v("Current Uploaded Market Demos Selection: " + _vm._s(_vm.fileUploaded))]), _vm._v(" "), _c('table', [_c('thead', [_c('tr', [(_vm.isNpower) ? _c('th', {
    staticClass: "market-break"
  }, [_vm._v("Market Break")]) : _vm._e(), _vm._v(" "), _c('th', {
    staticClass: "demo"
  }, [_vm._v("Demographic")]), _vm._v(" "), _c('th', [_vm._v("Target Audience")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.marketDemoOptions), function(md) {
    return _c('tr', [(_vm.isNpower) ? _c('td', [_c('span', [_vm._v(_vm._s(md.marketBreak))])]) : _vm._e(), _vm._v(" "), _c('td', [_c('span', [_vm._v(_vm._s(md.demographic))])]), _vm._v(" "), _c('td', {
      staticClass: "center"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (md.isSelected),
        expression: "md.isSelected"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "checked": Array.isArray(md.isSelected) ? _vm._i(md.isSelected, null) > -1 : (md.isSelected)
      },
      on: {
        "change": function($event) {
          var $$a = md.isSelected,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(md, "isSelected", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(md, "isSelected", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(md, "isSelected", $$c)
          }
        }
      }
    })])])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "select-market-demo__results-area"
  }, [_c('span', [_vm._v("DATA TO UPLOAD")]), _vm._v(" "), (_vm.hasDataCollisions) ? _c('div', {
    staticClass: "select-market-demo__error"
  }, [_c('icon', {
    attrs: {
      "name": "times-circle"
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.errorMessage))])], 1) : _vm._e(), _vm._v(" "), (_vm.hasOverwrites) ? _c('div', {
    staticClass: "select-market-demo__warning"
  }, [_c('icon', {
    attrs: {
      "name": "warning"
    }
  }), _vm._v(" "), _c('span', [_c('b', [_vm._v(_vm._s(_vm.overwriteCount.toLocaleString()))]), _vm._v(_vm._s(_vm.warningMessage))])], 1) : _vm._e(), _vm._v(" "), _c('table', [_c('thead', [_c('tr', [(_vm.isNpower) ? _c('th', {
    staticClass: "market-break"
  }, [_vm._v("Market Break")]) : _vm._e(), _vm._v(" "), _c('th', {
    staticClass: "demo"
  }, [_vm._v("Demographic")]), _vm._v(" "), _c('th', [_vm._v("Average UE (000)")]), _vm._v(" "), _c('th', [_vm._v("New Records")]), _vm._v(" "), _c('th', [_vm._v("Existing Records")]), _vm._v(" "), _c('th', [_vm._v("% of Complete Half Hours")]), _vm._v(" "), _c('th', [_vm._v("Network")]), _vm._v(" "), _c('th', [_vm._v("Quarter")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.marketDemoSegments), function(md) {
    return _c('tr', [(_vm.isNpower) ? _c('td', [_c('span', [_vm._v(_vm._s(md.MarketBreak))])]) : _vm._e(), _vm._v(" "), _c('td', [_c('span', [_vm._v(_vm._s(md.Demographic))])]), _vm._v(" "), _c('td', [_c('span', [_vm._v(_vm._s(Math.floor(md.AverageUEs / 1000).toLocaleString()))])]), _vm._v(" "), _c('td', [_c('span', [_vm._v(_vm._s(md.NumberOfRecords.toLocaleString()))])]), _vm._v(" "), _c('td', [_c('span', [_vm._v(_vm._s(_vm.existingQuarterNetworks[md.NetworkName + md.QuarterName] || 0))]), _vm._v(" "), (_vm.existingQuarterNetworks[md.NetworkName + md.QuarterName]) ? _c('icon', {
      staticClass: "select-market-demo__warning",
      attrs: {
        "name": "warning"
      }
    }) : _vm._e()], 1), _vm._v(" "), _c('td', [_c('span', [_vm._v(_vm._s(_vm.getRecordCompletionPercent(md.NumberOfRecords, md.NumberOfExpectedRecords)))])]), _vm._v(" "), _c('td', [_c('span', [_vm._v(_vm._s(md.NetworkName))])]), _vm._v(" "), _c('td', [_c('span', [_vm._v(_vm._s(md.QuarterName))])]), _vm._v(" "), (_vm.selectedQuarterNetworks[md.NetworkName + md.QuarterName].length > 1) ? _c('td', {
      staticClass: "select-market-demo__error"
    }, [_c('icon', {
      attrs: {
        "name": "times-circle"
      }
    })], 1) : _vm._e()])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "select-market-demo__upload-segments center"
  }, [_c('action-button', {
    attrs: {
      "disabled": !_vm.allowUpload,
      "label": "Upload Segments",
      "color": "success",
      "id": "uploadSegmentsBtn"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.uploadSegments.apply(null, arguments)
      }
    }
  })], 1), _vm._v(" "), _vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "select-market-demo__note-area"
  }, [_c('span', [_vm._v("NOTE: Audience must have 12 months of data & must be sent downstream from the dashboard")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-67bc3607"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/appComponents/targets/createTarget/forms/NpowerSelectSegmentModal.vue
// module id = 1917
// module chunks = 0